// @vendors
const moment = require('moment');
const { get } = require('lodash');
const { formatText } = require('core/i18n').i18n;
// @ utilities
const { APIPost } = require('utilities/APIRequestHelper');
const apiURLBuilder = require('core/apiURLBuilder');
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');
const RAAccountsHelper = require('../utilities/RAAccountsHelper');
const {
    recordProcess,
    PROC_RA_NEW_CONTRIBUTION,
    PROC_END,
    PROC_FAIL,
} = require('utilities/tagging');

// @actions
const signaturePatternActions = require('actions/signaturePattern');
const raErrorHandlerActions = require('./RAErrorHandler');
const { outdateMyInvestments } = require('actions/brokerMyInvestments');

// @constants
const actionTypes = require('../raConstants/actionTypes');
const transferCodes = require('constants/transferCodes');
const {
    EURO_TEXT,
    DATE_FORMAT_API,
    FIRST_STEP,
    SECOND_STEP,
    THIRD_STEP,
} = require('constants/index');
const {
    CONTRIBUTION_ISBAN_PERIOD_DAILY,
    CONTRIBUTION_ISBAN_PERIOD_WEEKLY,
    CONTRIBUTION_ISBAN_PERIOD_MONTHLY,
    CONTRIBUTION_PERIOD_DAILY,
    CONTRIBUTION_PERIOD_WEEKLY,
    CONTRIBUTION_PERIOD_MONTHLY,
    CONTRIBUTION_PERIOD_PUNCTUAL,
} = require('../raConstants/index');

const reset = () => ({
    type: actionTypes.RA_ADDITIONAL_CONTRIBUTION_RESET,
});

const validateForm = () => ({
    type: actionTypes.RA_ADDITIONAL_CONTRIBUTION_VALIDATE_FORM,
});

const additionalContributionSuccess = () => ({
    type: actionTypes.RA_ADDITIONAL_CONTRIBUTION_SUCCESS,
});

const additionalContributionInProgress = () => ({
    type: actionTypes.RA_ADDITIONAL_CONTRIBUTION_IN_PROGRESS,
});

const additionalContributionFailure = error => ({
    type: actionTypes.RA_ADDITIONAL_CONTRIBUTION_FAILURE,
    payload: {
        error,
    },
});

const validationMoneyFailure = error => ({
    type: actionTypes.RA_ADDITIONAL_CONTRIBUTION_VALIDATION_MONEY_FAILURE,
    payload: {
        error,
    },
});

const resetStep = step => ({
    type: actionTypes.RA_ADDITIONAL_CONTRIBUTION_RESET_STEP,
    payload: {
        step,
    },
});

const resetPortfolio = () => ({
    type: actionTypes.RA_ADDITIONAL_CONTRIBUTION_RESET_PORTFOLIO,
});

const setContributionDay = day => ({
    type: actionTypes.RA_ADDITIONAL_CONTRIBUTION_SET_CONTRIBUTION_DAY,
    payload: {
        day,
    },
});

const setVisibleStep = step => ({
    type: actionTypes.RA_ADDITIONAL_CONTRIBUTION_SET_VISIBLE_STEP,
    payload: {
        step,
    },
});

const validateUIStep = step => ({
    type: actionTypes.RA_ADDITIONAL_CONTRIBUTION_VALIDATE_UI_STEP,
    payload: {
        step,
    },
});

const setAdditionalContributionAmount = amount => ({
    type: actionTypes.RA_ADDITIONAL_CONTRIBUTION_SET_CONTRIBUTION_AMOUNT,
    payload: amount,
});

const setAdditionalContributionAccount = (
    accountId,
    accountBalance,
) => dispatch => {
    dispatch({
        type: actionTypes.RA_ADDITIONAL_CONTRIBUTION_SET_ACCOUNT,
        payload: { accountId, accountBalance },
    });
    dispatch(validateUIStep(SECOND_STEP));
};

const setPeriodicity = periodicity => ({
    type: actionTypes.RA_ADDITIONAL_CONTRIBUTION_SET_PERIODICITY,
    payload: {
        periodicity,
    },
});

const setRecurringContributionAmount = amount => dispatch => {
    dispatch({
        type:
            actionTypes.RA_ADDITIONAL_CONTRIBUTION_SET_RECURRING_CONTRIBUTION_AMOUNT,
        payload: {
            amount,
        },
    });
    dispatch(validateUIStep(FIRST_STEP));
};

const setPortfolio = portfolio => dispatch => {
    const periodicity = CONTRIBUTION_PERIOD_PUNCTUAL;

    dispatch({
        type: actionTypes.RA_ADDITIONAL_CONTRIBUTION_SET_PORTFOLIO,
        payload: {
            portfolio,
            periodicity,
        },
    });
    dispatch(validateUIStep(FIRST_STEP));
};

const recurringTrasferContributionValidationSuccess = response => ({
    type:
        actionTypes.RA_ADDITIONAL_CONTRIBUTION_RECURRING_TRANSFER_VALIDATION_SUCCESS,
    payload: {
        response,
    },
});

const additionalPunctualContribution = history => (dispatch, getState) => {
    const immGlobalPosition = getState().raGlobalPosition;
    const immAdditionalContribution = getState().raAdditionalContribution;
    const immAccounts = getState().accounts;

    const CONCEPT = formatText(
        'raAdditionalContribution-raAdditionalContribution_punctualConceptActionText',
    );
    const amount = immAdditionalContribution.getIn([
        'hireData',
        'contribution',
        'amount',
    ]);
    const accountId = immAdditionalContribution.getIn([
        'hireData',
        'selectedAccount',
        'id',
    ]);

    const contractNumber = immAccounts.getIn([
        'byId',
        accountId,
        'newContractNumber',
    ]);
    const productNumber = immAccounts.getIn(['byId', accountId, 'newProduct']);
    const beneficiaryAccount = immGlobalPosition
        .getIn([
            'roboAccount',
            immAdditionalContribution.get('portfolio'),
            'ibanComplex',
        ])
        .toJS();
    const beneficiaryName = immGlobalPosition.getIn([
        'roboAccount',
        immAdditionalContribution.get('portfolio'),
        'owner',
    ]);

    const params = {
        portfolioId: immAdditionalContribution.get('portfolio'),
    };

    const requestData = {
        header: {
            version: 2,
        },
        query: {
            autonomo: 'N',
            concepto: CONCEPT,
            contratoOrdenantePartenon: {
                numerodecontrato: contractNumber,
                producto: productNumber,
            },
            cuentaBeneficiario: beneficiaryAccount,
            fechaEmision: moment().format(DATE_FORMAT_API), // (andres): PAss money is always in the same day
            importe: {
                divisa: EURO_TEXT,
                importe: amount,
            },
            nombreTitularBeneficiario: beneficiaryName,
        },
    };

    dispatch(additionalContributionInProgress());
    return APIPost({
        dispatch,
        endpoint: 'passMoneyValidation',
        params: requestData,
    })
        .then(() => {
            const callback = (dispatch, getState, dataToken) => {
                const requestData = {
                    query: {
                        concepto: CONCEPT,
                        contratoOrdenantePartenon: {
                            numerodecontrato: contractNumber,
                            producto: productNumber,
                        },
                        cuentaBeneficiario: beneficiaryAccount,
                        divisaCtaOrd: EURO_TEXT,
                        importe: {
                            divisa: EURO_TEXT,
                            importe: amount,
                        },
                        indDivisa: '01',
                        nombreTitularBeneficiario: beneficiaryName,
                        tipoCtoExt: 1,
                        tipoTransferencia: {
                            indtipoperacion:
                                transferCodes.TRANSFER_PASS.OPERATION_ID,
                            naturalezapagomispag: {
                                codalfanum:
                                    transferCodes.TRANSFER_PASS.ALPHANUM,
                            },
                        },
                        dataToken,
                    },
                };

                const portfolioId = immAdditionalContribution.get('portfolio');
                const immPortfolio = immGlobalPosition.getIn([
                    'portfolios',
                    portfolioId,
                ]);
                const customData = {
                    processDetail:
                        'robo cartera ' +
                        immPortfolio.getIn(['product', 'typeOfProduct']),
                    amount: amount,
                };
                const isSecondVersion = true;

                return APIPost(
                    dispatch,
                    apiURLBuilder.getURL('raAdditionalContribution', params),
                    requestData,
                )
                    .then(() => {
                        dispatch(additionalContributionSuccess());
                        recordProcess(
                            PROC_RA_NEW_CONTRIBUTION,
                            PROC_END,
                            customData,
                            isSecondVersion,
                        );
                    })
                    .catch(error => {
                        if (error.error) {
                            dispatch(
                                additionalContributionFailure(
                                    error.error.description,
                                ),
                            );
                        } else {
                            throw error;
                        }

                        dispatch(raErrorHandlerActions.show(error, history));
                        recordProcess(
                            PROC_RA_NEW_CONTRIBUTION,
                            PROC_FAIL,
                            customData,
                            isSecondVersion,
                        );
                    });
            };

            if (__CONTACT_CENTER__ && isPrintOfficeMode()) {
                callback(
                    dispatch,
                    getState,
                    getState().signaturePattern.get('token'),
                );
            } else {
                signaturePatternActions.validateAndExecute(
                    dispatch,
                    getState,
                    callback,
                );
            }
        })
        .catch(error => {
            dispatch(validationMoneyFailure(error));
            dispatch(raErrorHandlerActions.show(error, history));
        });
};

const getPeriodicity = (recurringCode, contributionDay) => {
    switch (recurringCode) {
        case CONTRIBUTION_PERIOD_DAILY:
            return [
                {
                    dia: 1,
                    mes: 0,
                    tiempo: 1,
                },
                {
                    dia: 2,
                    mes: 0,
                    tiempo: 1,
                },
                {
                    dia: 3,
                    mes: 0,
                    tiempo: 1,
                },
                {
                    dia: 4,
                    mes: 0,
                    tiempo: 1,
                },
                {
                    dia: 5,
                    mes: 0,
                    tiempo: 1,
                },
            ];
        case CONTRIBUTION_PERIOD_WEEKLY:
            const day = moment().day();
            return [
                {
                    dia: day === 0 || day === 6 ? 1 : day,
                    mes: 0,
                    tiempo: 1,
                },
            ];
        case CONTRIBUTION_PERIOD_MONTHLY:
            return [
                {
                    dia: contributionDay,
                    mes: 0,
                    tiempo: 1,
                },
            ];
        default:
            return [];
    }
};

const recurringTrasferContributionValidation = history => (
    dispatch,
    getState,
) => {
    const immAccounts = getState().accounts;
    const immProfile = getState().profile;
    const immAdditionalContribution = getState().raAdditionalContribution;
    const immGlobalPosition = getState().raGlobalPosition;
    const immRightsProfile = getState().rightsProfile;
    const originAccountId = immAdditionalContribution.getIn([
        'hireData',
        'selectedAccount',
        'id',
    ]);
    const portfolioId = immAdditionalContribution.get('portfolio');
    const immPortfolio = immGlobalPosition.getIn(['portfolios', portfolioId]);
    const immOriginAccount = immAccounts.getIn(['byId', originAccountId]);
    const immDestinationAccount = immGlobalPosition.getIn([
        'roboAccount',
        portfolioId,
    ]);
    const recurringCode = immAdditionalContribution.get('periodicity');
    const ibanData = get(
        immRightsProfile.get('productsUser'),
        'datosSalidaCodIban.datosIban',
        [],
    );
    const oldOriginProductContract =
        immOriginAccount.get('product') +
        immOriginAccount.get('contractNumber');
    const oldOriginIbanContract = RAAccountsHelper.getOldIbanContract(
        ibanData,
        oldOriginProductContract,
    );
    const endDate = immPortfolio.get('hasGoal')
        ? moment(immPortfolio.getIn(['goalInformation', 'goalDate'])).format(
              DATE_FORMAT_API,
          )
        : '9999-01-01';
    let recurringIsbanCode;

    switch (recurringCode) {
        case CONTRIBUTION_PERIOD_DAILY:
            recurringIsbanCode = CONTRIBUTION_ISBAN_PERIOD_DAILY;
            break;
        case CONTRIBUTION_PERIOD_WEEKLY:
            recurringIsbanCode = CONTRIBUTION_ISBAN_PERIOD_WEEKLY;
            break;
        case CONTRIBUTION_PERIOD_MONTHLY:
            recurringIsbanCode = CONTRIBUTION_ISBAN_PERIOD_MONTHLY;
            break;
        default:
            recurringIsbanCode = '';
    }

    const periodicities = getPeriodicity(
        recurringCode,
        immAdditionalContribution.get('contributionDay'),
    );

    const request = {
        header: {
            version: 2,
        },
        query: {
            contratoOrdenante: {
                numeroContrato: immOriginAccount.get('newContractNumber'),
                producto: immOriginAccount.get('newProduct'),
            },
            contratoOrdenanteIban: oldOriginIbanContract,
            importe: {
                importe: immAdditionalContribution.getIn([
                    'hireData',
                    'contribution',
                    'amount',
                ]),
                divisa: EURO_TEXT,
            },
            concepto: formatText(
                'raAdditionalContribution-raAdditionalContribution_periodicConceptActionText',
            ),
            nombreCompletoBeneficiario: immProfile.get('fullname'),
            paisTransferencia: 'ES',
            divisaOrd: EURO_TEXT,
            indicadorResidenciaDestinatario: 'S',
            cuentaBeneficiario:
                immDestinationAccount.getIn(['ibanComplex', 'pais']) +
                immDestinationAccount.getIn([
                    'ibanComplex',
                    'digitodecontrol',
                ]) +
                immDestinationAccount.getIn(['ibanComplex', 'codbban']),
            tipoTransferencia: 'PERIODICA',
            fechaInicioVigencia: moment().format(DATE_FORMAT_API),
            indicadorPeriodicidad: {
                codigoalfanum3: recurringIsbanCode,
            },
            periodicidades: {
                periodicidad: periodicities,
            },
            fechaFinVigencia: endDate,
            indicadorTratamientoFechaEmis: 'P',
        },
    };

    return APIPost(
        dispatch,
        apiURLBuilder.getURL('transferValidation'),
        request,
    )
        .then(response => {
            dispatch(recurringTrasferContributionValidationSuccess(response));
        })
        .catch(error => {
            dispatch(raErrorHandlerActions.show(error, history));
        });
};

const validateStep = (step, history) => (dispatch, getState) => {
    dispatch(validateUIStep(step));
    const nextStep = step + 1;
    let valid;
    switch (step) {
        case FIRST_STEP:
            valid = getState().raAdditionalContribution.getIn([
                'steps',
                step,
                'valid',
            ]);
            if (valid) {
                dispatch(setVisibleStep(nextStep));
                dispatch(validateUIStep(nextStep));
            }
            break;
        case SECOND_STEP:
            const isPunctualPeriodicity =
                getState().raAdditionalContribution.get('periodicity') ===
                CONTRIBUTION_PERIOD_PUNCTUAL;

            //The line below is in order to call validation service only in the case in which we have monthly periodicity
            //This does not affect privada's behavior because they don't have the third step in punctual periodicity case
            //and so they don't have the next button in the second step
            !isPunctualPeriodicity &&
                dispatch(recurringTrasferContributionValidation(history));

            valid = getState().raAdditionalContribution.getIn([
                'steps',
                step,
                'valid',
            ]);
            if (valid) {
                dispatch(setVisibleStep(nextStep));
                dispatch(validateUIStep(nextStep));
            }
        case THIRD_STEP:
            valid = getState().raAdditionalContribution.getIn([
                'steps',
                step,
                'valid',
            ]);
            if (valid) {
                dispatch(setVisibleStep(nextStep));
            }
            break;
        default:
            break;
    }
};

const recurringTrasferContributionConfirmation = (
    dispatch,
    getState,
    dataToken,
    history,
) => {
    const immAccounts = getState().accounts;
    const immProfile = getState().profile;
    const immAdditionalContribution = getState().raAdditionalContribution;
    const immGlobalPosition = getState().raGlobalPosition;
    const immRightsProfile = getState().rightsProfile;
    const originAccountId = immAdditionalContribution.getIn([
        'hireData',
        'selectedAccount',
        'id',
    ]);
    const portfolioId = immAdditionalContribution.get('portfolio');
    const immPortfolio = immGlobalPosition.getIn(['portfolios', portfolioId]);
    const immOriginAccount = immAccounts.getIn(['byId', originAccountId]);
    const immDestinationAccount = immGlobalPosition.getIn([
        'roboAccount',
        portfolioId,
    ]);
    const ibanData = get(
        immRightsProfile.get('productsUser'),
        'datosSalidaCodIban.datosIban',
        [],
    );
    const oldOriginProductContract =
        immOriginAccount.get('product') +
        immOriginAccount.get('contractNumber');
    const oldOriginIbanContract = RAAccountsHelper.getOldIbanContract(
        ibanData,
        oldOriginProductContract,
    );
    const recurringCode = immAdditionalContribution.get('periodicity');
    const endDate = immPortfolio.get('hasGoal')
        ? moment(immPortfolio.getIn(['goalInformation', 'goalDate'])).format(
              DATE_FORMAT_API,
          )
        : '9999-01-01';
    let nextExecutionDate;
    const cutDay = immAdditionalContribution.get('contributionDay');

    switch (recurringCode) {
        case CONTRIBUTION_PERIOD_DAILY:
            nextExecutionDate = moment().add(1, 'days');
            break;
        case CONTRIBUTION_PERIOD_WEEKLY:
            nextExecutionDate = moment().add(1, 'weeks');
            break;
        case CONTRIBUTION_PERIOD_MONTHLY:
            const cutDayDate = moment().date(cutDay);
            nextExecutionDate = moment().isBefore(cutDayDate)
                ? cutDayDate.add(1, 'months')
                : cutDayDate;
            break;
        default:
            nextExecutionDate = '';
    }

    const request = {
        query: {
            amount: immAdditionalContribution.getIn([
                'hireData',
                'contribution',
                'amount',
            ]),
            clientName: immProfile.get('fullname'),
            currency: EURO_TEXT,
            dataToken: dataToken,
            originAccount: {
                codIban: oldOriginIbanContract,
                numberContract: immOriginAccount.get('newContractNumber'),
                product: immOriginAccount.get('newProduct'),
            },
            recurringCode,
            cutDay,
            startDate: moment()
                .add(1, 'days')
                .format(DATE_FORMAT_API),
            endDate,
            nextExecutionDate: nextExecutionDate.format(DATE_FORMAT_API),
            targetActiveAccount: {
                accountNumber: immAdditionalContribution.getIn([
                    'recurringValidationData',
                    'actuanteBeneficiario',
                    'numeroActuante',
                ]),
                typeCode: immAdditionalContribution.getIn([
                    'recurringValidationData',
                    'actuanteBeneficiario',
                    'codTipoActuante',
                ]),
            },
            targetCgdAccount: {
                codIban:
                    immDestinationAccount.getIn(['ibanComplex', 'pais']) +
                    immDestinationAccount.getIn([
                        'ibanComplex',
                        'digitodecontrol',
                    ]) +
                    immDestinationAccount.getIn(['ibanComplex', 'codbban']),
            },
            context: '{}', // optional parameter
        },
    };

    const params = {
        portfolioId,
    };

    const customData = {
        processDetail:
            'robo cartera ' + immPortfolio.getIn(['product', 'typeOfProduct']),
        amount: immAdditionalContribution.getIn([
            'hireData',
            'contribution',
            'amount',
        ]),
    };
    const isSecondVersion = true;

    return APIPost(
        dispatch,
        apiURLBuilder.getURL('raRecurringTransferConfirmation', params),
        request,
    )
        .then(response => {
            dispatch(additionalContributionSuccess(response));
            dispatch(outdateMyInvestments());
            recordProcess(
                PROC_RA_NEW_CONTRIBUTION,
                PROC_END,
                customData,
                isSecondVersion,
            );
        })
        .catch(error => {
            dispatch(additionalContributionFailure(error.error.description));
            dispatch(raErrorHandlerActions.show(error, history));

            recordProcess(
                PROC_RA_NEW_CONTRIBUTION,
                PROC_FAIL,
                customData,
                isSecondVersion,
            );
        });
};

const getAdditionalContributionPDFFetching = data => ({
    type: actionTypes.RA_ADDITIONAL_CONTRIBUTION_GET_PDF_FETCHING,
    payload: data,
});

const getAdditionalContributionPDFSuccess = data => ({
    type: actionTypes.RA_ADDITIONAL_CONTRIBUTION_GET_PDF_SUCCESS,
    payload: data,
});

const getAdditionalContributionPDFFailure = data => ({
    type: actionTypes.RA_ADDITIONAL_CONTRIBUTION_GET_PDF_FAILURE,
    payload: data,
});

const getAdditionalContributionPDF = () => (dispatch, getState) => {
    const immAdditionalContribution = getState().raAdditionalContribution;
    const immGlobalPosition = getState().raGlobalPosition;
    const immAccounts = getState().accounts;

    dispatch(getAdditionalContributionPDFFetching());

    const hasPuntualPeriodicity =
        immAdditionalContribution.get('periodicity') ===
        CONTRIBUTION_PERIOD_PUNCTUAL;
    const amount = immAdditionalContribution.getIn(
        ['hireData', 'contribution', 'amount'],
        null,
    );
    let transferDay;
    const associatedAccount = immAdditionalContribution.getIn(
        ['hireData', 'selectedAccount', 'id'],
        null,
    );
    const selectedAccountAlias = immAccounts.getIn([
        'byId',
        associatedAccount,
        'description',
    ]);
    const selectedAccountContract = immAccounts.getIn([
        'byId',
        associatedAccount,
        'oldFullContractNumber',
    ]);
    const account = `${selectedAccountAlias.trim()} ...${selectedAccountContract.slice(
        -4,
    )}`;
    const portfolioId = immAdditionalContribution.get('portfolio');
    const contractNumber = immGlobalPosition.getIn([
        'roboAccount',
        portfolioId,
        'contract',
        'contractNumber',
    ]);
    const portfolioName = immGlobalPosition.getIn([
        'portfolios',
        portfolioId,
        'name',
    ]);
    const currentPortfolioValue = immGlobalPosition.getIn([
        'totalPortfolios',
        portfolioId,
        'keyFigures',
        'valuation',
    ]);
    const currentPortfolioCurrency = immGlobalPosition.getIn([
        'totalPortfolios',
        portfolioId,
        'currency',
    ]);

    let periodicity;
    if (!hasPuntualPeriodicity) {
        switch (immAdditionalContribution.get('periodicity')) {
            case CONTRIBUTION_PERIOD_DAILY:
                periodicity = 'D';
                transferDay = '';
                break;
            case CONTRIBUTION_PERIOD_WEEKLY:
                periodicity = 'W';
                transferDay = '';
                break;
            case CONTRIBUTION_PERIOD_MONTHLY:
                periodicity = 'M';
                transferDay = immAdditionalContribution.get('contributionDay');
                break;
            default:
                break;
        }
    }

    const requestData = {
        query: {
            amount: amount,
            associatedAccount: account,
            channel: isPrintOfficeMode ? 'OFI' : 'CC',
            contractNumber: contractNumber,
            currency: currentPortfolioCurrency,
            currentAmount: currentPortfolioValue,
            periodicity: periodicity,
            portfolioName: portfolioName,
            transferDay: transferDay,
            transferType: hasPuntualPeriodicity ? 'D' : 'R',
        },
    };
    APIPost(
        dispatch,
        apiURLBuilder.getURL('raPdfAditionalContribution'),
        requestData,
    )
        .then(response => {
            if (!response.errorMessage) {
                dispatch(getAdditionalContributionPDFSuccess(response));
            } else {
                dispatch(getAdditionalContributionPDFFailure());
            }
        })
        .catch(() => dispatch(getAdditionalContributionPDFFailure()));
};

const finish = history => (dispatch, getState) => {
    const immAdditionalContribution = getState().raAdditionalContribution;
    const hasPuntualPeriodicity =
        immAdditionalContribution.get('periodicity') ===
        CONTRIBUTION_PERIOD_PUNCTUAL;

    if (hasPuntualPeriodicity) {
        dispatch(additionalPunctualContribution(history));
    } else {
        const callback = (dispatch, getState, dataToken) => {
            recurringTrasferContributionConfirmation(
                dispatch,
                getState,
                dataToken,
                history,
            );
        };

        dispatch(additionalContributionInProgress());
        signaturePatternActions.validateAndExecute(
            dispatch,
            getState,
            callback,
        );
    }
};

module.exports = {
    finish,
    reset,
    resetStep,
    setVisibleStep,
    setAdditionalContributionAccount,
    setAdditionalContributionAmount,
    setContributionDay,
    setPeriodicity,
    setPortfolio,
    setRecurringContributionAmount,
    validateForm,
    validateStep,
    resetPortfolio,
    getAdditionalContributionPDF,
};
